// extracted by mini-css-extract-plugin
export default {"cell":"table-cell_cell__QwxkG","align-start":"table-cell_align-start__DKhNt"};